export const CHECK_DESTINATIONS = [
	{
		id: "CASH_ACCOUNT",
		name: "Conta de caixa",
		explanation: "Transferência da conta Itaú 58000 para a conta de caixa selecionada",
	},
	{
		id: "OUTBOUND_FREIGHT",
		name: "Frete de saída — CIF",
		explanation: "Pagamento de frete de saída por cheque",
	},
	{
		id: "OTHER",
		name: "Outro destino",
		explanation: null,
	},
] as const;

export type CheckDestinationId = (typeof CHECK_DESTINATIONS)[number]["id"];

export interface ConfirmedCheckDestination {
	id: number;
	checkNumber: string;
	destinationId: CheckDestinationId;
	cashAccountId: "caixa-amanda" | "caixa-sindi" | null;
	destination: string;
	explanation: string;
	actor: string;
	confirmedAt: string;
}

const destinationById = new Map(
	CHECK_DESTINATIONS.map((destination) => [destination.id, destination]),
);

export const CheckDestinations = {
	fromFormValue(value: string): CheckDestinationId | "" {
		switch (value) {
			case "":
			case "CASH_ACCOUNT":
			case "OUTBOUND_FREIGHT":
			case "OTHER":
				return value;
			default:
				throw new Error(`Destino de cheque inválido: ${value}`);
		}
	},

	normalizeCheckNumber(checkNumber: string) {
		const digits = checkNumber.trim();

		if (!/^\d{1,12}$/u.test(digits)) {
			throw new Error("Número do cheque inválido");
		}

		return digits.padStart(6, "0");
	},

	presentation(
		destinationId: CheckDestinationId,
		cashAccountId: ConfirmedCheckDestination["cashAccountId"] = null,
	) {
		const destination = destinationById.get(destinationId);

		if (!destination) {
			throw new Error(`Destino de cheque inválido: ${destinationId}`);
		}

		if (destinationId !== "CASH_ACCOUNT") {
			return destination;
		}
		if (cashAccountId === "caixa-amanda") {
			return {
				...destination,
				name: "Caixa Amanda",
				explanation: "Transferência da conta Itaú 58000 para o Caixa Amanda",
			};
		}
		if (cashAccountId === "caixa-sindi") {
			return {
				...destination,
				name: "Caixa Sindi",
				explanation: "Transferência da conta Itaú 58000 para o Caixa Sindi",
			};
		}

		throw new Error("Selecione o caixa que recebeu o dinheiro");
	},

	explanation(
		destinationId: CheckDestinationId,
		cashAccountId: ConfirmedCheckDestination["cashAccountId"],
		explanation: string | null,
	) {
		const destination = CheckDestinations.presentation(destinationId, cashAccountId);

		if (destination.explanation) {
			return destination.explanation;
		}

		const confirmedExplanation = explanation?.trim();

		if (!confirmedExplanation) {
			throw new Error("Explique o outro destino do cheque");
		}

		return confirmedExplanation;
	},
};
